export default "__VITE_ASSET__CBpIkE1z__"